import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react-lite';

import { usePageSettings } from '@ratehub/base-ui';

import isBodyBlock from '../functions/isBodyBlock';
import getConditionalComponents from '../functions/getConditionalComponents';
import shouldHideBackgroundCircle from '../functions/shouldHideBackgroundCircle';
import Layout from './Layout';
import BlockRenderer from './BlockRenderer';


function WordpressPage({ blocks = [], blockMap, ...otherProps }) {
    const pageSettings = usePageSettings();
    const {
        businessUnit,
        hideBackgroundImage,
    } = pageSettings;

    const [ hideBackgroundCircle, setHideBackgroundCircle ] = useState(hideBackgroundImage);

    /* If a location is specified, it means it's not meant for the main body */
    const blocksWithoutLocation = blocks.filter(isBodyBlock);

    useEffect(() => {
        setHideBackgroundCircle(shouldHideBackgroundCircle(blocksWithoutLocation));
    }, []);

    return (
        <Layout
            blocks={blocks}
            hideBackgroundImage={hideBackgroundCircle}
            blockMap={blockMap}
            {...otherProps}
        >
            <BlockRenderer
                blocks={blocksWithoutLocation}
                blockMap={blockMap}
            />

            {getConditionalComponents({ businessUnit, pageBlocks: blocks })}
        </Layout>
    );
}

WordpressPage.propTypes = {
    blocks: PropTypes.array.isRequired,
    blockMap: PropTypes.object.isRequired,
};


export default observer(WordpressPage);
